import { jsx as _jsx } from "react/jsx-runtime";
import { nodeComponentRegistry } from '../NodeComponentRegistry.js';
import { fallbackTransform } from '../nodeFallbackTransform.js';
import { GenericNodeFallback } from '../internal/generic-node-fallback/index';
import { ErrorBoundary } from './ErrorBoundary.js';
import { MissingResourcePlaceholder } from './MissingResourcePlaceholder.js';
export function GuardedNodeComponent({ node, children, }) {
    const Component = nodeComponentRegistry.get(node.type) ?? GenericNodeFallback;
    return (_jsx(ErrorBoundary, { resetKeys: [node], fallback: () => (_jsx(MissingResourcePlaceholder, { shape: "box", name: node.name, ...fallbackTransform(node) })), children: _jsx(Component, { node: node, children: children }) }));
}
//# sourceMappingURL=GuardedNodeComponent.js.map